import { Alert, Box, Button, Stack, Typography } from '@mui/material'
import { useMemo } from 'react'
import { CloseWindowButton } from '@/components/CloseWindowButton'
import { useAppSelector } from '@/redux/hooks'
import {
  selectActiveValuesForSubmission,
  selectValidationOfActiveValues,
} from '../selectors'
import type { BulkEditValidationError } from '../types'

type FormActionProps = {
  onSubmit: () => void
}

export const FormActions = (props: FormActionProps) => {
  const { onSubmit } = props
  const [isValid, errors] = useAppSelector(selectValidationOfActiveValues())
  const forSubmit = useAppSelector(selectActiveValuesForSubmission())
  const noChanges = Object.keys(forSubmit).length === 0

  const errorAlerts = useMemo(() => {
    if (!isValid) {
      return errors.map((err: BulkEditValidationError) => (
        <Alert key={`${err.field}: ${err.errorMessages}`} severity="warning">
          {err.field}: {err.errorMessages.join(' ')}
        </Alert>
      ))
    }
  }, [errors])

  return (
    <Box py={4}>
      {!isValid && (
        <Typography>Resolve the following errors to continue:</Typography>
      )}
      {errorAlerts}
      <Stack justifyContent="end" direction="row" py={3} gap={1}>
        <CloseWindowButton />
        <Button
          disabled={!isValid || noChanges}
          variant="contained"
          color="primary"
          onClick={onSubmit}
        >
          Review & Submit
        </Button>
      </Stack>
    </Box>
  )
}
